import React from 'react'

import HarveyLogo from '@harvey-frontend/components/common/harvey-logo'
import { Button } from '@harvey-frontend/components/ui/button'

const TITLE = 'Harvey for Word'
const DESCRIPTION = 'Reimagine how you draft'

interface LandingProps {
  title?: string
  description?: string
  showButton?: boolean
  isButtonDisabled?: boolean
  openAuthDialog?: () => void
  buttonText?: string
  showLearnMore?: boolean
}

const Landing = ({
  title,
  description,
  showButton = true,
  isButtonDisabled,
  openAuthDialog,
  buttonText = 'Get started',
  showLearnMore = true,
}: LandingProps) => {
  const handleGetStarted = () => {
    openAuthDialog && openAuthDialog()
  }

  return (
    <div className="flex h-screen w-full flex-col">
      <div className="flex flex-1 flex-col items-center justify-center gap-4">
        <div className="flex h-[60px] w-[60px] items-center justify-center rounded-sm bg-accent px-3.5 py-4 text-[56px]">
          <HarveyLogo className="w-12" />
        </div>
        <div className="flex flex-col items-center justify-center">
          <h1 className="text-xl font-semibold">{title ? title : TITLE}</h1>
          <p className="text-xs text-muted">
            {description ? description : DESCRIPTION}
          </p>
        </div>
      </div>
      {showButton && (
        <div className="flex flex-col items-center gap-2 pb-10 pt-4">
          <div className="flex w-full max-w-[350px] flex-col gap-2 px-6">
            <Button
              disabled={isButtonDisabled}
              onClick={handleGetStarted}
              className="flex justify-center px-4 py-1.5"
            >
              {buttonText}
            </Button>
            {showLearnMore && (
              <a
                href="https://www.harvey.ai"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button
                  variant="ghost"
                  disabled={isButtonDisabled}
                  className="w-full text-xs text-secondary transition hover:bg-transparent hover:text-muted"
                >
                  Learn more
                </Button>
              </a>
            )}
          </div>
        </div>
      )}
    </div>
  )
}

export default Landing
